$.widget("bluaul.Heatmap", $.common.VisualBase, {

    _create: function () {
        /**sets global values and inital values
         *
         */
        var me = this;
        try {
            /**
            * set the Visual-Name first
            * after that execute the parent function (_super())
            * to load the visual into the root-element
            */
            me.options.invoke.vcvid = 303;
            //archive resolution
            me.resolution = 1;
            //number of days in the chart
            me.days = 1;
            //bsaid for the temperature singal
            me.bsaidTemp = -1;

            me.yAxisLabels1 = [
                "00:15", "00:30", "00:45",
                "01:00", "01:15", "01:30", "01:45", "02:00", "02:15", "02:30", "02:45", "03:00", "03:15", "03:30", "03:45",
                "04:00", "04:15", "04:30", "04:45", "05:00", "05:15", "05:30", "05:45", "06:00", "06:15", "06:30", "06:45",
                "07:00", "07:15", "07:30", "07:45", "08:00", "08:15", "08:30", "08:45", "09:00", "09:15", "09:30", "09:45",
                "10:00", "10:15", "10:30", "10:45", "11:00", "11:15", "11:30", "11:45", "12:00", "12:15", "12:30", "12:45",
                "13:00", "13:15", "13:30", "13:45", "14:00", "14:15", "14:30", "14:45", "15:00", "15:15", "15:30", "15:45",
                "16:00", "16:15", "16:30", "16:45", "17:00", "17:15", "17:30", "17:45", "18:00", "18:15", "18:30", "18:45",
                "19:00", "19:15", "19:30", "19:45", "20:00", "20:15", "20:30", "20:45", "21:00", "21:15", "21:30", "21:45",
                "22:00", "22:15", "22:30", "22:45", "23:00", "23:15", "23:30", "23:45", "24:00"
            ];
            me.yAxisLabels4 = [
                "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "24:00"
            ];

            me.yAxisLabels8 = [
                "02:00", "04:00", "06:00", "08:00", "10:00", "12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"
            ];

            me.yAxisLabels12 = [
                "03:00", "06:00", "09:00", "12:00", "15:00", "18:00", "21:00", "24:00"
            ];

            //me.yAxisLabels4 = [
            //    "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
            //    "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "24:00"
            //];

            Highcharts.setOptions({ global: { useUTC: false } });
            //inits the super class
            me._super();


        } catch (e) {
            me.writeError('_create', e); return false;
        }
        return true;
    },
    _initHTML: function () {
        var me = this;
        var from, to;
        try {

            if (me.specific.isStandAlone === 'true') { $("#i-share-url").vcShareUrlIcon({ invokeType: "addVisualBase", vcgid: me.options.invoke.vcgid }) };
            /**
             * get current Dropdown into variable and replace with vcOptionBox with it inside
             */
            var htmlSelectSignals = me.element.find(".navigation .select-signals").clone();

            me.element.find(".navigation .select-signals").replaceWith(
                $("<div>", { "class": "select-signals-box vc-grid-3col  vc-grid-margin-right" })
            );
            me.element.find(".navigation .select-signals-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.signals_lbl, clickable: false, isList: true, content: htmlSelectSignals.clone() }]
            });


            var htmlSelectDataType = me.element.find(".navigation .select-datatype").clone();

            me.element.find(".navigation .select-datatype").replaceWith(
                $("<div>", { "class": "select-datatype-box vc-grid-2col  vc-grid-margin-right" })
            );

        
            me.element.find(".navigation .select-datatype-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.datatype_lbl, clickable: false, isList: true, content: htmlSelectDataType.clone() }]
            });


            if (me.specific.isStandAlone === 'true') {

                from = moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").subtract(90, 'days').format("DD.MM.YYYY");
                to = moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
            } else {



                from = moment(me.options.parameter.startDate, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
                to = moment(me.options.parameter.endDate, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
            }

            //me.resources.signals_lbl
            me.element.find(".vc-date-box").addClass("vc-grid-margin-right").vcDateBox({
                mode: "Range",
                align: "right",
                interval: 1,
                defaultRange: { from: from, to: to },
                langID: me.settings.userLangIDForCulture,
                callback: function () { }
            });

            //################################ Calc Height ################################


            me.chartHeight = me.visual.height() - me.visual.find(".navigation").height();

            me.visual.find("#divVC" + me.vcgid + "-chart").height(me.chartHeight);

            //load charts

            me._loadAllCharts(me.visual.find("#divVC" + me.vcgid + "-chart"));



        } catch (e) {
            me.writeError('_initHTML', e); return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //inits the refresh button
            me.element.on("click", ".navigation .refresh", function () { me._loadAllCharts(); });
            //toggles the temperature button
            me.visual.find(".navigation .show-temp").on("click", function () {

                if ($(this).hasClass("button-toggle-active")) {
                    $(this).removeClass("button-toggle-active");
                } else {
                    $(this).addClass("button-toggle-active");
                }
            });
            // me.visual.find(".navigation .show-temp").button();
        } catch (e) {
            me.writeError('_initEvents', e); return false;
        }
        return true;
    },


    _loadAllCharts: function () {
        /** This function checks if only one or both charts should get shown, calculates heights and starts
         * the first (main) chart.
         */
        var me = this;
        var h;

        try {
            h = me.chartHeight;
            //find out if we need the temperature chart as well
            if (me.visual.find(".navigation .show-temp").hasClass("button-toggle-active")) {
                me.bsaidTemp = parseInt(me.visual.find(".navigation .show-temp").data("bsaid"));
            } else {
                me.bsaidTemp = -1;
            }
            if (me.bsaidTemp > 0) {
                me.visual.find("#divVC" + me.vcgid + "-chart").height(parseInt(h * 0.65)).html(me.getLoadingIcon());
                me.visual.find("#divVC" + me.vcgid + "-chart-temp").show().height(parseInt(h * 0.34))
                    .html(me.getLoadingIcon());
            } else {
                me.visual.find("#divVC" + me.vcgid + "-chart").height(h).html(me.getLoadingIcon);
                me.visual.find("#divVC" + me.vcgid + "-chart-temp").hide();
            }


            me._loadChart(me.visual.find("#divVC" + me.vcgid + "-chart"), true);


        } catch (e) {
            me.writeError('_loadAllCharts', e); return false;
        }
        return true;
    },
    _loadChart: function (obj, bMain) {
        /** This function generates the settings and fetches the chart data
         *  optionally it starts the second chart (for the temperature ) as well when everything is finished.
         */
        var me = this;
        var dateRange;
        var param;
        var dataType;
        var bsaid;
        var from, to;
        try {
            //if it's the main chart we get the bsaid for the signal otherwise we get the bsaid for the temperature
            if (bMain) {
                bsaid = me.element.find(".navigation .select-signals option:selected").val();
            } else {
                bsaid = me.bsaidTemp;
            }

            dateRange = me.element.find(".navigation .vc-date").vcDate("getDate");
            from = moment(dateRange.from, "DD.MM.YYYY");
            to = moment(dateRange.to, "DD.MM.YYYY");
            me.options.parameter = {};
            me.options.parameter.startDate = dateRange.from;
            me.options.parameter.endDate = dateRange.to;


            //we adopt the resolution based on the number of days we have to show
            me.days = to.diff(from, 'days');
            if (me.days <= 365) { me.resolution = 1 };
            if (me.days > 365) { me.resolution = 4 };
            if (me.days > 730) { me.resolution = 8 };
            if (me.days > 1095) { me.resolution = 12 };

            //we only show 1h values for the differential
            dataType = parseInt(me.element.find(".navigation .select-datatype option:selected").val());
            if (dataType === 3 || bMain === false) {
                if (me.resolution === 1) {
                    me.resolution = 4;
                }
            }
            //we only show 1 h values for the temperature
            if (bMain === false) {
                if (me.resolution < 8) {
                    me.resolution = 4;
                }
            }


            //set param for ajax request
            param = {
                LoggerId: me.settings.blid,
                Bsaid: bsaid,
                StartDate: me.options.parameter.startDate,
                EndDate: me.options.parameter.endDate,
                Resolution: me.resolution,
                DataType : dataType
            };

            //send the config for the share url
            var p  = {
                LoggerId: me.settings.blid,
                Bsaid: bsaid,
                startDate: dateRange.from,
                endDate: dateRange.to,
                Resolution: me.resolution,
                DataType: dataType,
                isStandAlone:false
            };
        
            _VCMQ.produce(me.visual, me.options.invoke.vcgid, 'GET_EXPORT_URL_SETTINGS',
                {
                    'info': { bsaid: bsaid, name: '', description: '', startDate: p.startDate, endDate: p.endDate, dateUserDef: true, interval: 1 },
                     'visualname': "HEATMAP","vcvid":me.vcvid, 'parameter': JSON.stringify(p), 'signalparameter': ""
                });

         

            window.VisualCoreService.getData(me.vcvid, me.vcgid, me.getCurrentTimestamp(), me.container.height, me.container.width, JSON.stringify(p), '', me.settings.deviceType, me.settings.langID, JSON.stringify(param), function (result) {
                //check response content
                
                if (result === null) {
                    obj.html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return false;
                } else if (result.length < 1 || result === {}) {
                  
                    obj.html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return false;
                }
                //change string dateformat to unix timestamp
                result.data = result.filter(function (item) {
                    item.x = moment(item.x, "DD.MM.YYYY").valueOf();
                    return item;
                });
                //generate the highchart
                me._generateChart(obj, result, bMain);
                if (bMain) {
                    //optionally we load the second chart
                    if (me.bsaidTemp > -1) {
                        me._loadChart(me.visual.find("#divVC" + me.vcgid + "-chart-temp"), false);
                    }
                }
                return true;
            });

        } catch (e) {
            me.writeError('_loadChart', e); return false;
        }
        return true;
    },

    _generateChart: function (obj, data, bMain) {
        /** this function generates the highchart and has some stuff to do for differeing between the main and the temperature chart */
    var me = this;
    var yCategories = [];
        var bLegend = true;
    var yTickInterval = 1;
        var signal;
        try {

            if (bMain) {
                signal = me.element.find(".navigation .select-signals option:selected").text();
            } else {
                signal = me.specific.resources.temperature_lbl + " [°C]";

            }
            switch (me.resolution) {
            case 1:
                yCategories = me.yAxisLabels1;
                yTickInterval = 5;
                break;
            case 4:
                yCategories = me.yAxisLabels4;
                break;
            case 8:
                yCategories = me.yAxisLabels8;
                break;
            case 12:
                yCategories = me.yAxisLabels12;
                break;
            
        default:
        }

        var ro = new RampOptions();
        ro.deviceType = me.specific.deviceType;
            ro.mobile = false;
            ro.width = me.options.invoke.container.width;

            var chart = ro.getTheme();


            //var tick = Math.floor(data[0].x);

            //console.info(tick);


       if (me.options.invoke.deviceType === 2) { bLegend = false }
       var tmp = Highcharts.merge(chart,
           {
               chart: {
                   renderTo: obj.prop("id"),

                   type: 'heatmap',
                   height: obj.height(),
                   marginTop: 5,
                   spacingBottom: 15,
                   spacingRight: 0
               },
              
                boost: { useGPUTranslations: true},
                title: { text: '' },
                subtitle: { text: '' },
                legend: { height: 50,margin:10 },
                exporting: {
                    enabled: bLegend,
                    buttons: {
                        contextButton: {
                            menuItems: ['preview', 'separator', 'downloadJPEG', 'downloadPNG', 'downloadPDF'],
                            x: -6
                        }
                    }
                },
                xAxis: {
                        type: "datetime",
                      offset:1,
                    tickPositioner: function () {
                     
                        var positions = [];
                        var tick = Math.floor(this.dataMin);
                      
                        var d = me.days;
                        if (me.days > 30) {
                            d = 30;
                        }
                       
                        if (this.dataMax === this.dataMin) {
                            positions.push(tick);
                        } else {


                            var s = moment(me.options.parameter.startDate, "DD.MM.YYYY");
                            var e = moment(me.options.parameter.endDate, "DD.MM.YYYY")
                         
                            increment = Math.floor(e.diff(s, 'days') / d) * 86400000;
                          
                        if (this.dataMax !== null && this.dataMin !== null) {
                            for (tick; tick - increment <= this.dataMax; tick += increment) {
                                positions.push(tick);
                            }
                        }
                        }
                            return positions;
                    },
                    labels: {
                     
                        formatter: function() {
                            if (bMain) {

                                return moment(this.value).format("DD.MM.YYYY");
                            } else {
                                return "";
                            }
                    },
                        rotation: -90,
                        y: 15,
                        showFirstLabel: true
                    }
                },
                yAxis: {
                    offset: 1,
                    tickInterval: yTickInterval,
                    categories: yCategories,
                    title: {
                        text: null
                    },
                    labels: {
                        padding: 0
                    }
                        
                },
                plotOptions: {
                    series: {
                        states: {
                            hover: {
                                halo: {size:0},
                                enabled: false
                            }
                        }
                    }
                },
                colorAxis: {
                    stops: [
                        [0, '#030eff'],
                        [0.2, '#02fdfe'],
                        [0.4, '#5cee24'],
                        [0.6, '#fff904'],
                        [0.8, '#fe8600'],
                        [1, '#fa0200']
                    ],

                    startOnTick: false,
                    endOnTick: false,
                    // stops: me._generateColor(result.color, '#ffffff', 5),
                    labels: {
                        format: '{value}'
                    }
                },

                series: [
                    {
                        data: data,
                        boostThreshold: 0,
                        borderWidth: 0,
                        nullColor: '#f8f8f8',
                        clip: false,
                        crisp:false,
                        colsize: 23 * 38e5,

                        turboThreshold: Number.MAX_VALUE
                        , heatmap: {crisp:false,clip:false, states: { hover: {enabled:false}}}
                    }
                ],
                tooltip: {
                
                    formatter: function () {
                      
                        return "<u>" + signal + "</u><br/>"+ moment(this.point.x).format("DD.MM.YYYY") +
                            " " +
                            yCategories[this.point.y] +
                            " " + me.specific.resources.clock_lbl + ": " +
                            Highcharts.numberFormat(this.point.value, 3, ',', '.');

                    }
                }

            });

        if (!bMain) {
            tmp.yAxis.tickInterval = 2;
            tmp.yAxis.startOnTick= false;
            tmp.yAxis.showLastLabel = false;
            //tmp.yAxis.showFirstLabel = false;
        }

            window.__GLOBAL_VISUAL_LIST["heatmap"] = new Highcharts.chart( tmp);

        return true;

    } catch(e) {
            me.writeError('_generateChart', e); return false;
        }
    }

});
